/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page3_Info_ContactInputs */



/**
* | output |
* | --- |
* | "If you do not have the required Eisox equipment, request a quote at: support@eisox.com" |
*
* @param {Intervention_Plan_Pdf_Page3_Info_ContactInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page3_info_contact = /** @type {((inputs?: Intervention_Plan_Pdf_Page3_Info_ContactInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page3_Info_ContactInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("If you do not have the required Eisox equipment, request a quote at: support@eisox.com")
	return /** @type {LocalizedString} */ ("Si vous ne disposez pas du materiel Eisox necessaire à l'intervention, vous pouvez demander un devis à l'adresse : support@eisox.com")
});